import { render, staticRenderFns } from "./VFile.vue?vue&type=template&id=639212c2&scoped=true&"
import script from "./VFile.vue?vue&type=script&lang=js&"
export * from "./VFile.vue?vue&type=script&lang=js&"
import style0 from "./VFile.vue?vue&type=style&index=0&id=639212c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639212c2",
  null
  
)

export default component.exports